SupportV2DealSummaryView = require('./v2_deal_summary_view')
SupportV2OrderSummaryView = require('./v2_order_summary_view')
SupportCurrentOrderView = require('./current_order_view')
SupportServiceActionMainView = require('./service_action_main_view')

class SupportV2CurrentOrderView extends SupportCurrentOrderView

  createDealSummaryView: ->
    @dealSummary = new SupportV2DealSummaryView()

  createOrderSummaryView: ->
    @orderSummary = new SupportV2OrderSummaryView()

  createServiceActionView: ->
    @serviceActionMain = new SupportServiceActionMainView({
      showLinksAndButtons: true
    })

  render: ->
    @renderSubViews()
    if @serviceActionMain?.serviceActions?.length > 0
      @layoutView()
    else
      SupportCurrentOrderView::layoutView.call(this)

  layoutView: ->
    @dealSummary.$el.addClass('eight columns')
    $('.deal-image', @dealSummary.$el).addClass('three columns')
    $('.deal-info', @dealSummary.$el).addClass('nine columns')
    @orderSummary.$el.addClass('nine columns')
    @dealSummary.$el.append(@orderSummary.$el)
    @$el.append(@dealSummary.el)
    unless @options.hideSelfServiceActions
      @serviceActionMain.$el.addClass('four columns')
      $linkServiceActions = $( ".#{@serviceActionMain.linkIdentifier()}", @serviceActionMain.el).detach()
      $defaultServiceActions = $( ".#{@serviceActionMain.defaultButtonIdentifier()}", @serviceActionMain.el)
      $secondaryServiceActions = $( ".#{@serviceActionMain.secondaryButtonIdentifier()}", @serviceActionMain.el)
      if $defaultServiceActions.length > 0 || $secondaryServiceActions.length > 0
        @$el.append(@serviceActionMain.el)

      if $linkServiceActions.length > 0
        $('.deal-image', @dealSummary.$el).append($linkServiceActions)

module.exports = SupportV2CurrentOrderView
